import { RouteRecordRaw } from "vue-router"

export const layoutRoutes: RouteRecordRaw[] = [
	{
		path: "/",
		component: () => import("@/views/layout/index.vue"),
		redirect: "/pairedReading",
		children: [
			{
				path: "/pairedReading",
				component: () => import("@/views/pairedReading/index.vue")
			},
			{
				path: "/record",
				component: () => import("@/views/record/components/tab.vue"),
				redirect: "/record/all",
				children: [
					{
						path: "/record/all",
						component: () => import("@/views/record/index.vue"),
					},
					{
						path: "/record/diaryList",
						component: () => import("@/views/record/diaryList.vue")
					},
					{
						path: "/record/albumList",
						component: () => import("@/views/record/albumList.vue")
					},
				]
			},
			{
				path: "/check",
				component: () => import("@/views/check/index.vue"),
				redirect: "/check/parenting",
				children: [
					{
						path: "/check/parenting",
						component: () => import("@/views/check/parenting.vue")
					},
					{
						path: "/check/read",
						component: () => import("@/views/check/read.vue")
					},
					{
						path: "/check/iMaths",
						component: () => import("@/views/check/iMaths.vue")
					},
					{
						path: "/check/art",
						component: () => import("@/views/check/art.vue")
					},
				]
			},
			{
				path: "/mine",
				component: () => import("@/views/mine/index.vue")
			},
		],

	},
	{
		path: "/search",
		component: () => import("@/views/pairedReading/search.vue")
	},
	{
		path: "/bookDetail",
		component: () => import("@/views/pairedReading/bookDetail.vue")
	},
]
